import type CSS from 'csstype'
import styled from 'styled-components'

type FlexDirection = CSS.Property.FlexDirection

export const Container = styled.div<{ hideButtons?: boolean; inputDirection?: FlexDirection }>`
  display: flex;
  align-items: center;
  flex-direction: ${({ inputDirection = 'row' }) => inputDirection};
  gap: 20px;

  & #button-minus,
  #button-plus {
    display: inline-block;
    @media (min-width: 1240px) {
      display: ${({ hideButtons }) => (hideButtons ? 'none' : 'inline-block')};
    }
  }
`
export const SliderContainer = styled.div`
  z-index: 98;
  display: none !important;
  @media (min-width: 1240px) {
    position: relative;
    min-width: 280px;
    padding-right: 15px;
    vertical-align: middle;
    display: inline-block !important;
  }
`
